import { render, staticRenderFns } from "./Detail-Claim.vue?vue&type=template&id=a3665a12"
import script from "./Detail-Claim.vue?vue&type=script&lang=js"
export * from "./Detail-Claim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports